import styled from 'styled-components';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';

export const breakpoints = {
    sDesktop: '1365px',
    tablet: '1023px',
    mobile: '767px',
};

export const Wrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: auto;
    margin: 40px 0 10px;
    margin-bottom: 0;
    border-bottom: 1px solid ${COLORS.grey};
    user-select: none;
    white-space: nowrap;

    @media (max-width: 500px) {
        margin: 25px 0 0;
    }
`;

export const NewMenuItem = styled.a`
    display: inline-block;
    padding: 12px 0;
    margin-bottom: -1px;
    ${FONTS.Medium};
    color: ${p => p.active ? COLORS.black : COLORS.darkGrey};
    border-bottom: ${p => p.active ? `2px solid ${COLORS.red}` : 'none'};
    cursor: pointer;
    transition: color .2s;
    &:hover {
        color: ${p => p.active ? COLORS.black : COLORS.darkGrey};
    }
    &:first-of-type {
        margin-right: 33px;
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        ${FONTS.S};
    }

    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.XS};
    }
`;
